"use strict";

var _jquery = require("jquery");
var _jquery2 = _interopRequireDefault(_jquery);
require("bootstrap");
require("slick-carousel");
var _sweetalert = require("sweetalert2/src/sweetalert2");
var _sweetalert2 = _interopRequireDefault(_sweetalert);
var _jsCookie = require("js-cookie");
var _jsCookie2 = _interopRequireDefault(_jsCookie);
require("./scss/frontend/style.scss");
require("./js/_section-banner-slider");
require("./js/_section-sku-slider");
require("./js/_section-menu");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
window.jQuery = _jquery2.default;
window.$ = _jquery2.default;
(0, _jquery2.default)(function () {
  if (!_jsCookie2.default.get('cookiebar') == 1) {
    _sweetalert2.default.fire({
      position: "bottom-left",
      title: "Política general sobre Cookies",
      text: "En Wong.pe nos preocupamos por mejorar tu experiencia de compra, sin descuidar la protección de tus datos personales. En consecuencia Wong.pe, usa dos tipos de cookies las Funcionales y las de Analítica y Optimización ¿consiente el uso de las cookies?",
      confirmButtonText: "Sí Acepto",
      showCancelButton: false,
      cancelButtonText: "Cerrar",
      allowOutsideClick: true,
      allowEscapeKey: true,
      backdrop: 'swal2-backdrop-show',
      footer: '<div class="content-footer" style="width:100%;display:inline-block; text-align:center;"><a href="https://wong.pe/institucional/politicas-de-cookies" target="_blank" style=";display:inline-block; margin:0 10px;"><u>Política de Cookies</u></a></div>',
      customClass: {
        container: 'swal2-shown',
        htmlContainer: 'swal2-content'
      }
    }).then(function (result) {
      if (result.isConfirmed) {
        _jsCookie2.default.set('cookiebar', 1, {
          expires: 365,
          path: '/'
        });
      }
      _sweetalert2.default.close();
    });
  }
  var interval;
  (0, _jquery2.default)('header .menubar .button-arrow-prev, header .menubar .button-arrow-next').on('touchend mouseup mouseout', function () {
    clearInterval(interval);
  });
  (0, _jquery2.default)('header .menubar .button-arrow-prev').on('touchstart mousedown', function () {
    clearInterval(interval);
    interval = setInterval(function () {
      var prev = (0, _jquery2.default)('#mainmenu').scrollLeft();
      (0, _jquery2.default)('#mainmenu').scrollLeft(prev - 10);
    }, 10);
  });
  (0, _jquery2.default)('header .menubar .button-arrow-next').on('touchstart mousedown', function () {
    clearInterval(interval);
    interval = setInterval(function () {
      var prev = (0, _jquery2.default)('#mainmenu').scrollLeft();
      (0, _jquery2.default)('#mainmenu').scrollLeft(prev + 10);
    }, 10);
  });
  (0, _jquery2.default)('.section-submenu a').on('click', function (event) {
    if ((0, _jquery2.default)('.section-submenu-space + .template-section-title-h2').attr('id') == (0, _jquery2.default)(this).attr('href').replace("#", "")) {
      event.preventDefault();
      (0, _jquery2.default)([document.documentElement, document.body]).animate({
        scrollTop: -100
      }, 200);
    }
  });
  if (jQuery('#mainmenu .active').length == 0) return;
  document.getElementById('mainmenu').scrollLeft = jQuery('#mainmenu .active').offset().left - 15;
});